export default __webpack_public_path__ + "static/maria-6db5684379cf149cac1e8b92b14335b7.png";